const KEY_TOKEN = "key-token";
const KEY_TOKENUSER = "key-tokenUser"

export const storage = {

    setToken: (value) => {
        localStorage.setItem(KEY_TOKEN, value);
    },

    getToken: () => {

        var response = localStorage.getItem(KEY_TOKEN);

        if (response == null || response == undefined || response == "") {
            return null;
        }

        return response;
    },

    setTokenUser: (value) => {
        localStorage.setItem(KEY_TOKENUSER, value);
    },

    getTokenUser: () => {

        var response = localStorage.getItem(KEY_TOKENUSER);

        if (response == null || response == undefined || response == "") {
            return null;
        }

        return response;
    }

}